// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"00c57e226b284649af5b","655":"ba0ade2ec4edc77c0b86"}[chunkId] + ".js";
};